import { render, staticRenderFns } from "./AddonProductModal.vue?vue&type=template&id=b5961680&"
import script from "./AddonProductModal.vue?vue&type=script&lang=js&"
export * from "./AddonProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5961680')) {
      api.createRecord('b5961680', component.options)
    } else {
      api.reload('b5961680', component.options)
    }
    module.hot.accept("./AddonProductModal.vue?vue&type=template&id=b5961680&", function () {
      api.rerender('b5961680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/AddonProductModal.vue"
export default component.exports